import { makeStyles } from "@material-ui/styles";

const useStylesExpansionPanel = makeStyles((theme) => ({
  root: {
    borderRadius: 8,
    margin: "8px 0",
    padding: 0,
    "&$expanded": {
      margin: "8px 0",
    },

    "&:before": {
      display: "none", // remove a linha superior padrão do ExpansionPanel
    },
  },
  summary: {
    minHeight: 36, // Altura mínima menor que o padrão
    height: 36,
    margin: 0,
    padding: "24px 20px",
    "&$expanded": {
      minHeight: 36,
      height: 36,
      margin: 0,
    },
  },
  expanded: {}, // Necessário para a $expanded funcionar
  content: {
    background: "transparent",
  },
  margin: 0,
  list: {
    width: "100%",
  },
  listItem: {
    paddingLeft: 8,
    marginBottom: 2,
  },
}));

export default useStylesExpansionPanel;
